import { CustomizedStyle } from "./style/CustomizedStyle";
/**
 * Holds a single maplibre stylesheet that can be customized.
 */
export class BaseLayer {
    constructor(url) {
        this.url = url;
    }
    /**
     * Gets the layers in this base layer but customized with the given source for roads.
     *
     * @param roadSourceId The source if for roads.
     *
     * @returns A set of customized layers.
     */
    async buildCustomizedStyle(roadSource) {
        // make sure style is fetched.
        await this.fetchStyle();
        // copy style and customize.
        const style = JSON.parse(JSON.stringify(this.originalStyle));
        if (typeof roadSource !== "undefined") {
            this.customizeWithSource(style, roadSource.sourceId);
            style.sources[roadSource.sourceId] = roadSource.source;
        }
        // get the lowest layer per type.
        const styleLayers = style.layers;
        const layers = [];
        const lowestByType = {};
        styleLayers.forEach((layer, i) => {
            // add layer without a position.
            // the position will be update later.
            layers.push({ layer: layer });
            // get layer type.
            const layerType = this.getLayerType(layer);
            if (typeof layerType === "undefined")
                return; // no type.
            // see if type has been hit before.
            if (typeof lowestByType[layerType] !== "undefined")
                return; // already seen.
            lowestByType[layerType] = layer.id;
            // update layers below this position.
            for (let l = i - 1; l >= 0; l--) {
                const layerAndPosition = layers[l];
                if (typeof layerAndPosition.isBehind !== "undefined")
                    break;
                layerAndPosition.isBehind = layerType;
            }
        });
        style.layers = [];
        return new CustomizedStyle(style, layers, lowestByType);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getLayerType(layer) {
        throw new Error("getLayerType not implemented");
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    customizeWithSource(style, roadSourceId) {
        throw new Error("customizeWithSource not implemented");
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
    onAfterFetch(style) {
    }
    async fetchStyle() {
        if (typeof this.originalStyle === "undefined") {
            const styleResponse = await fetch(this.url);
            this.originalStyle = await styleResponse.json();
            this.onAfterFetch(this.originalStyle);
        }
    }
}
